import { createApp } from "vue";
import { createPinia } from 'pinia';
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "@/assets/main.scss";
import './registerServiceWorker';
import '@mdi/font/css/materialdesignicons.css';
import formatterPlugins from "@/plugins/formatterPlugins";

loadFonts();
const app = createApp(App);
const pinia = createPinia();

app.use(router).use(vuetify).use(pinia).use(formatterPlugins).mount("#app");
